import { useFormContext } from 'react-hook-form';

import {
  ContractedBenefitsSettings,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';

export const useIsMyChoiceValid = (
  contractedBenefits: ContractedBenefitsSettings[]
) => {
  const { watch } = useFormContext<ICreateBenefitGroupForm>();
  const benefitSettings = watch('benefitSettings');

  return (
    contractedBenefits.filter(
      ({ benefitType, myChoiceEnabled }) =>
        myChoiceEnabled && !!benefitSettings?.[benefitType]
    ).length > 1
  );
};
